import PropTypes from "prop-types";
import isEmpty from "lodash.isempty";
import { Form, FormCheck, FormGroup } from "react-bootstrap";
import TextInputWithAttachments from "./TextInputWithAttachments";
import useMessageAttachments from "../hooks/useMessageAttachments";
import React from "react";

const MessageFormField = (props) => {
    const { field, handleInputs, inputValues, attachmentsEnabled, handleAttachments } = props;
    const { fileConfig } = useMessageAttachments();

    let type = field.type;

    if (field.field_id.toLowerCase() === 'notification_sms') {
        type = 'tel';
    } else if (field.field_id.toLowerCase() === 'notification_email') {
        type = 'email';
    }

    const radioButtonsElement = (
        <FormGroup id={field.field_id} key={field.field_id} className="mb-3">
            <Form.Label>{field.name}</Form.Label>
            {field.options.map((option, index) => (
                <FormCheck
                    type='radio'
                    id={`option-${field.field_id}-${index}`}
                    name={`option-${field.field_id}`}
                    key={option.object_key}
                    value={option.object_key}
                    label={option.label}
                    required={parseInt(field.required) === 1}
                    onChange={(e) => handleInputs({
                        target: {
                            id: field.field_id,
                            value: e.target.value,
                            checkValidity: () => e.target.checkValidity(),
                            classList: e.target.classList
                        }
                    })}
                    checked={inputValues[field.field_id] === option.object_key ? inputValues[field.field_id] : false}
                />
            ))}
        </FormGroup>
    )

    const textFieldElement = (
        <FormGroup key={field.field_id}>
            <Form.Floating className="mb-3">
                <Form.Control
                    id={field.field_id}
                    type={type}
                    required={parseInt(field.required) === 1}
                    placeholder={field.description}
                    onChange={(e) => handleInputs(e)}
                    pattern={type === 'tel' ? '^\\+\\d{1,14}$' : undefined}
                    maxLength={255}
                />
                <Form.Label htmlFor={field.field_id}>{field.name}</Form.Label>
                <Form.Control.Feedback type="invalid"/>
            </Form.Floating>
        </FormGroup>
    )

    const textAreaWithFilesElement = (
        <FormGroup key={field.field_id}>
            <Form.Floating>
                <TextInputWithAttachments
                    fieldId={field.field_id}
                    fieldName={field.description}
                    required={true}
                    acceptedFileAmount={fileConfig.acceptedFileAmount}
                    attachmentsEnabled={attachmentsEnabled}
                    acceptedFileTypes={fileConfig.acceptedFileTypes}
                    acceptedFileSize={fileConfig.acceptedFileSize}
                    byteConversionFactor={fileConfig.byteConversionFactor}
                    sizeUnit={fileConfig.sizeUnit}
                    handleInputChange={handleInputs}
                    handleAttachments={handleAttachments}
                    updateCommentSubmitValue={(_value) => true}
                />
            </Form.Floating>
        </FormGroup>
    )

    if (field.description.toUpperCase() === 'HIDDEN' || isEmpty(field.name)) {
        return null;
    } else if (type === 'any') {
        return field.options.length > 0 ? radioButtonsElement : null;
    } else if (field.field_id.toLowerCase() === 'description') {
        return textAreaWithFilesElement;
    } else {
        return textFieldElement;
    }
}

MessageFormField.propTypes = {
    field: PropTypes.object.isRequired,
    handleInputs: PropTypes.func.isRequired,
    inputValues: PropTypes.object.isRequired,
    attachmentsEnabled: PropTypes.bool.isRequired,
    handleAttachments: PropTypes.func.isRequired
};

export default MessageFormField;
